import {useBoAgentAccessCheck} from '@access-control';
import {routes} from '@config';

import {
    playerLevelReportBasicResource,
    playerLevelReportCasinoResource,
    playerLevelReportGlobalSpinsResource,
    playerLevelReportPlayerActivityResource,
    playerLevelReportPokerMttResource,
    playerLevelReportPokerNhleSdResource,
    playerLevelReportPokerPloResource,
    playerLevelReportPokerResource,
    playerLevelReportShareResource,
    playerLevelReportSportsResource,
} from './permissions';

export function useDefaultPlayerLevelReportRoute() {
    const availableRoutes = [
        useBoAgentAccessCheck(playerLevelReportShareResource) ? routes.playerLevelReportShare : null,
        useBoAgentAccessCheck(playerLevelReportBasicResource) ? routes.playerLevelReportBasic : null,
        useBoAgentAccessCheck(playerLevelReportPokerResource) ? routes.playerLevelReportPoker : null,
        useBoAgentAccessCheck(playerLevelReportPokerNhleSdResource) ? routes.playerLevelReportPokerNhleSd : null,
        useBoAgentAccessCheck(playerLevelReportPokerMttResource) ? routes.playerLevelReportPokerMtt : null,
        useBoAgentAccessCheck(playerLevelReportPokerPloResource) ? routes.playerLevelReportPokerPlo : null,
        useBoAgentAccessCheck(playerLevelReportCasinoResource) ? routes.playerLevelReportCasino : null,
        useBoAgentAccessCheck(playerLevelReportGlobalSpinsResource) ? routes.playerLevelReportGlobalSpins : null,
        useBoAgentAccessCheck(playerLevelReportSportsResource) ? routes.playerLevelReportSports : null,
        useBoAgentAccessCheck(playerLevelReportPlayerActivityResource) ? routes.playerLevelReportPlayerActivity : null,
    ];

    return availableRoutes.find(route => route !== null);
}
